import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import _ from "lodash";
import { twMerge } from "tailwind-merge";
import { withDefaults, computed, HTMLAttributes, useAttrs, provide } from "vue";

export type ProvideThead = {
  variant?: "default" | "light" | "dark";
};

interface TheadProps extends HTMLAttributes {
  variant?: "default" | "light" | "dark";
}


const __default__ = {
  inheritAttrs: false,
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Thead',
  props: {
    variant: { default: "default" }
  },
  setup(__props: any) {

const props = __props as { variant: "default" | "light" | "dark" }



const attrs = useAttrs();

const computedClass = computed(() =>
  twMerge([
    props.variant === "light" && "bg-slate-200/60 dark:bg-slate-200",
    props.variant === "dark" && "bg-dark text-white dark:bg-black/30",
    typeof attrs.class === "string" && attrs.class,
  ])
);

provide<ProvideThead>("thead", {
  variant: props.variant,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("thead", _mergeProps({ class: _unref(computedClass) }, _unref(_).omit(_unref(attrs), 'class')), [
    _renderSlot(_ctx.$slots, "default")
  ], 16))
}
}

})